export const mimeToExtensionMap: { [key: string]: string } = {
  "application/msword": "doc",
  "application/zip": "collection",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
  "application/vnd.ms-excel": "xls",
  "text/csv": "csv",
  "application/pdf": "pdf",
};
